import { Injectable } from "@angular/core";
import { BehaviorSubject, distinctUntilChanged } from "rxjs";

@Injectable({ providedIn: "root" })
export class DropzoneService {
  private _dropzone$ = new BehaviorSubject<string[]>([]);
  dropzone$ = this._dropzone$.pipe(distinctUntilChanged());

  setDropzone(dropzone: string) {
    this._dropzone$.next([...this._dropzone$.value, dropzone]);
  }
}
